/* global wpApiSettings */
import React, { useEffect, useState } from "react";
import {
  getAllFavorites,
  getAllFavoritesData,
  removeFavorite,
} from "../store/thunks/favorites.thunks";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "./LoadingSpinner";
import { formatNumber } from "../utils/numberUtils";
import { RiDeleteBinFill } from "react-icons/ri";
import { ToastContainer, toast } from "react-toastify";
import { FaCalendarDays } from "react-icons/fa6";
import { fetchCurrUser } from "../store/thunks/users.thunks";
import moment from "moment";
import axios from "axios";

const Favorites = () => {
  const {
    favorites: cars,
    favorites_data: carData,
    isLoading,
    isFavoriteLoading,
  } = useSelector((state) => state.favorites);
  const dispatch = useDispatch();
  const userId = wpApiSettings.currentUserId;
  const [houseImgs, setHouseImgs] = useState({}); // Store images by car ID

  useEffect(() => {
    const userProceed = () => {
      dispatch(getAllFavorites({ userId }))
        .unwrap()
        .then((data) => {
          console.log("Favorites loaded:", data);
        })
        .catch((error) => {
          console.error("Failed to load favorites:", error);
        });
    };

    const fetchUserData = async () => {
      try {
        const response = await dispatch(fetchCurrUser()).unwrap();
        if (response && response.userId) {
          userProceed(); // Proceed with fetching favorites once the user is fetched
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    if (userId) {
      userProceed();
    } else {
      fetchUserData();
    }
  }, [userId, dispatch]);

  useEffect(() => {
    if (cars.length > 0) {
      const fetchData = async () => {
        try {
          await dispatch(getAllFavoritesData(cars)).unwrap();
        } catch (error) {
          console.error("Failed to fetch favorites data:", error);
        }
      };

      fetchData();
    }
  }, [cars, dispatch]);

  useEffect(() => {
    carData.forEach(car => {
      if ((car?.type === "housing-for-sale" || car?.type === "housing-long-term" || car?.type === "housing-short-term") && car?.address?.address) {
        const fetchStreetViewImage = async (carId, houseAddress) => {
          try {
            const url = 'https://maps.googleapis.com/maps/api/streetview';
            const response = await axios.get(url, {
              params: {
                size: '600x300',
                location: houseAddress,
                key: process.env.REACT_APP_GOOGLE_API, // Ensure this is set in your environment variables
              },
              responseType: 'blob',
            });

            const imageBlob = URL.createObjectURL(response.data);
            setHouseImgs(prev => ({ ...prev, [carId]: imageBlob }));
          } catch (error) {
            console.error('Error fetching the Street View image:', error);
          }
        };

        fetchStreetViewImage(car.id, car.address.address);
      }
    });
  }, [carData]);

  if (isLoading || isFavoriteLoading) {
    return (
      <LoadingSpinner
        text="Please wait..."
        height="80"
        width="80"
        strokeWidth="4"
        animationDuration="1.0"
      />
    );
  }

  const handleDelete = async (car) => {
    let itemName = "";
  
    if ([28835, 28920, 28919, 28928, 28955, 28956, 28957, 28958, 28959, 28960, 28961, 28962, 28963, 28964, 28965, 28966, 28967, 28968, 28969, 28970, 28977, 28971, 28972, 28973, 28974, 28975, 68, 28978, 28979, 28980, 28981, 28982, 28983, 28984, 28985, 28986, 28987, 28988, 28994, 28990, 28989, 28991, 28992, 28993, 73, 70, 71, 28941, 28942, 28943, 28944, 28945, 28946, 28947, 28948, 28949, 28950, 28951, 28952, 28953, 28954, 72, 28995, 28996, 28997, 28998, 28999, 29000, 29001, 29002, 29003, 29004, 29005, 29006, 29007, 29008, 29009, 29010, 29011, 29012, 29013, 29014, 29015, 92].includes(car?.hp_listing_category?.[0])) {
      itemName = car?.title?.rendered || "";
    } else if (car?.hp_listing_category?.[0] === 28928) {
      itemName = `${car?.hp_listing_v_details_condition?.[0]?.name?.toUpperCase() || ""} ${
        car?.meta?.hp_v_essentials_year || ""
      } ${car?.meta?.hp_v_essentials_make || ""} ${car?.meta?.hp_v_essentials_make_model || ""}`.trim();
    } else if (
      car?.type === "car" ||
      car?.type === "motorcycle" ||
      car?.type === "heavy-equipment"
    ) {
      itemName = `${car?.inventory_type === "used" ? "USED" : ""} ${
        car?.inventory_type === "new" ? "NEW" : ""
      } ${car?.build?.year || ""} ${car?.build?.make || ""} ${car?.build?.model || ""}`.trim();
    } else if(car?.type === "rv"){
      itemName = `${car?.inventory_type === "used" ? "USED" : ""} ${
        car?.inventory_type === "new" ? "NEW" : ""
      }${car?.heading|| ""}`.trim();
    } else if (car?.type === "housing-for-sale" || car?.type === "housing-long-term" || car?.type === "housing-short-term") {
      itemName = car?.address?.address || "";
    }
  
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the ${itemName}?`
    );
    if (!confirmDelete) return;
  
    try {
      await dispatch(removeFavorite({ author: car.id, userId })).unwrap();
      toast.success(
        `The ${itemName} has been deleted successfully`
      );
    } catch (error) {
      toast.warning("There's something wrong. Please try again later.");
      console.error("Failed to remove favorite:", error);
    }
  };
  
  const renderImage = (car) => {
    let imgElement;

    if ([28835, 28920, 28919, 28928, 28955, 28956, 28957, 28958, 28959, 28960, 28961, 28962, 28963, 28964, 28965, 28966, 28967, 28968, 28969, 28970, 28977, 28971, 28972, 28973, 28974, 28975, 68, 28978, 28979, 28980, 28981, 28982, 28983, 28984, 28985, 28986, 28987, 28988, 28994, 28990, 28989, 28991, 28992, 28993, 70, 73, 71, 28941, 28942, 28943, 28944, 28945, 28946, 28947, 28948, 28949, 28950, 28951, 28952, 28953, 28954, 72, 28995, 28996, 28997, 28998, 28999, 29000, 29001, 29002, 29003, 29004, 29005, 29006, 29007, 29008, 29009, 29010, 29011, 29012, 29013, 29014, 29015, 92].includes(car?.hp_listing_category?.[0])){
      imgElement = <img src={car.featured_image_url} alt={"Image"} />;
    } else if (car?.type === "car" || car?.type === "motorcycle" || car?.type === "heavy-equipment" || car?.type === "rv") {
      imgElement = <img src={car?.media?.photo_links[0]} alt={"Image"} />;
    } else if (car?.type === "housing-for-sale" || car?.type === "housing-long-term" || car?.type === "housing-short-term") {
      if (houseImgs[car.id]) {
        imgElement = <img src={houseImgs[car.id]} alt={"Street View"} />;
      } else {
        imgElement = <p>No Street View image available</p>;
      }
    }

    return imgElement;
  };

  const renderTitle = (car) => {
    let titleElement;
  
    if ([28835, 28920, 28919, 28928, 28955, 28956, 28957, 28958, 28959, 28960, 28961, 28962, 28963, 28964, 28965, 28966, 28967, 28968, 28969, 28970, 28977, 28971, 28972, 28973, 28974, 28975, 68, 28978, 28979, 28980, 28981, 28982, 28983, 28984, 28985, 28986, 28987, 28988, 28994, 28990, 28989, 28991, 28992, 28993, 70, 73, 71, 28941, 28942, 28943, 28944, 28945, 28946, 28947, 28948, 28949, 28950, 28951, 28952, 28953, 28954, 72, 28995, 28996, 28997, 28998, 28999, 29000, 29001, 29002, 29003, 29004, 29005, 29006, 29007, 29008, 29009, 29010, 29011, 29012, 29013, 29014, 29015, 92].includes(car?.hp_listing_category?.[0])) {
      titleElement = car?.title?.rendered?.toUpperCase() || "";
    } else if (car?.hp_listing_category?.[0] === 28928) {
      titleElement = (
        <>
          {car?.hp_listing_v_details_condition?.[0]?.name?.toUpperCase() || ""}{" "}
          {car?.meta?.hp_v_essentials_year && `${car.meta.hp_v_essentials_year} `} 
          {car?.meta?.hp_v_essentials_make && `${car.meta.hp_v_essentials_make} `} 
          {car?.meta?.hp_v_essentials_make_model && `${car.meta.hp_v_essentials_make_model}`}
        </>
      );
    } else if (car?.type === "car" || car?.type === "motorcycle" || car?.type === "heavy-equipment" || car?.type === "rv") {
      titleElement = (
        <>
          {car?.inventory_type === "used" && "USED"}{" "}
          {car?.inventory_type === "new" && "NEW"}{" "}
          {car?.build?.year && `${car.build.year} `} 
          {car?.build?.make && `${car.build.make} `} 
          {car?.build?.model && car.build.model}
        </>
      );
    } else if (car?.type === "housing-for-sale" || car?.type === "housing-long-term" || car?.type === "housing-short-term") {
      titleElement = (
        <>
          {car?.address?.address && car?.address?.address}
        </>
      );
    } else {
      titleElement = null;
    }
  
    return titleElement;
  };
  
  const renderOriginalName = (car) => {
    return (car?.hp_listing_category?.[0] === 28928 || car?.type === "car" || car?.type === "motorcycle" || car?.type === "heavy-equipment" || car?.type === "rv") ? (
      <span
  className="original-name"
  dangerouslySetInnerHTML={{
    __html: car?.title?.rendered || car?.heading || "Default Title",
  }}
></span>

    ) : null;
  };

  return (
    <>
      <div className="card-grid">
        {userId !== "0" ? (
          carData && carData.length === 0 ? (
            <h2 className="info-heading">
              You don't have any favorites saved yet.
            </h2>
          ) : null
        ) : (
          <h2 className="info-heading">
            Please sign in to access your favorites.
          </h2>
        )}

        {carData.map((car, index) => (
          <div key={index} className="car-card">
            <div className="delete-btn" onClick={() => handleDelete(car)}>
              <RiDeleteBinFill size={17} />
            </div>
            <a
              href={`/test-detail-page/?detail_id=${car.id}${
                car?.type !== "" ? `&type=${car.type}` : ""
              }`}
            >
              <div>
                {renderImage(car)}
              </div>
            </a>
            <div className="content">
              <h3>
                <a
                  href={`/test-detail-page/?detail_id=${car.id}${
                    car?.type !== "" ? `&type=${car.type}` : ""
                  }`}
                >
                  {renderTitle(car)}
                </a>
                {renderOriginalName(car)}
              </h3>
              <span className="car-attr flex" style={{ marginTop: "-10px" }}>
                <FaCalendarDays />
                <span>
                  <i>{moment(car?.comment_date).format("MMM D, YYYY")}</i>
                </span>
              </span>
              <span className="car-attr price-tag">
                $
                {car?.meta?.hp_price || car?.price || car?.mlsListingPrice
                  ? formatNumber(
                      car?.meta?.hp_price ||
                        car?.price ||
                        car?.mlsListingPrice
                    )
                  : "N/A"}
              </span>
            </div>
          </div>
        ))}
      </div>
      <ToastContainer 
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default Favorites;
